// Imports for external libraries go here.
import { FC, useEffect, useState } from 'react';

import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client';
import { phoenixLegalConsentsListQuery } from '@marriott/mi-legal-graphql';
import { getApplicableAndSortedConsents, isEmpty } from '../../utils/consents';
import { ConsentsList } from './ConsentsList';
import { ConsentErrorType } from './ConsentsList/ConsentsList.types';
import { LegalConsent, LegalConsentsProps, PhoenixLegalConsentsListType } from './LegalConsents.types';
import { Messages } from '@marriott/mi-ui-library';
import { StyledLegalConsents } from './LegalConsents.styles';
import { generateApolloClientHeadersForUXLCalls } from '../../utils/uxlHelper';

export const LegalConsents: FC<LegalConsentsProps> = ({
  sessionId,
  countryCode,
  isValidateErrors,
  locale,
  customLoader,
  option,
  consentsState,
  setConsentsState,
  onConsentChange,
}) => {
  const [consentsReponse, setConsentsReponse] = useState([] as LegalConsent[]);
  const [getLegalConsentsUxl, { loading }] = useLazyQuery<PhoenixLegalConsentsListType>(phoenixLegalConsentsListQuery);

  // const getLegalConsents = () => {
  //   const uxlOptions: LazyQueryHookOptions = {
  //     // variables: { locale },
  //     context: {
  //       // uri: 'https://marriott-sites2-qa.adobecqms.net/graphql/execute.json/legal-consents/Locale-specific',
  //       // uri: '/graphql/execute.json/legal-consents/getCountryConsents',
  //       headers: {
  //         'x-request-id': `Phoenix-Legal-${sessionId}`,
  //       },
  //     },
  //     fetchPolicy: 'network-only',
  //   };
  //   return getLegalConsentsUxl(uxlOptions);
  // };

  const getLegalConsents = () => {
    const uxlOptions: LazyQueryHookOptions = {
      variables: { locale },
      context: generateApolloClientHeadersForUXLCalls(sessionId, 'phoenixLegalConsentsListQuery', locale),
      fetchPolicy: 'network-only',
    };
    return getLegalConsentsUxl(uxlOptions);
  };

  useEffect(() => {
    const fetchLegalConsents = async () => {
      const legalConsentsRep = await getLegalConsents();
      // const allConsents = legalConsentsRep.data?.sectionsList.items || [];
      const allConsents =
        legalConsentsRep.data?.content?.legal?.legalConsentsByLocale?.aemData?.data?.sectionsList.items || [];

      if (isEmpty(allConsents)) {
        setConsentsReponse([] as LegalConsent[]);
        setConsentsState({
          sectionTypes: {},
          list: [] as LegalConsent[],
          consentsLedger: {},
          error: { type: ConsentErrorType.NONE, message: null },
        });
        return;
      }

      const sortedConsentListData = getApplicableAndSortedConsents({
        allConsents,
        preStateLedger: consentsState?.consentsLedger,
        countryCode,
        option,
      });

      console.log('sortedConsentListData payload ', {
        allConsents,
        preStateLedger: consentsState?.consentsLedger,
        countryCode,
        option,
      });
      console.log('sortedConsentListData ', sortedConsentListData);

      setConsentsReponse(allConsents);
      setConsentsState(sortedConsentListData);
    };
    fetchLegalConsents();
  }, [locale]);

  // If option changes then
  // We dont have to call the API again to to fetch the data
  // Pass the same response as previous and filter out applicable consent list with repect to new option value
  useEffect(() => {
    const sortedConsentListData = getApplicableAndSortedConsents({
      allConsents: consentsReponse,
      countryCode,
      option,
    });
    setConsentsState(sortedConsentListData);
    console.log('sortedConsentListData payload ', {
      consentsReponse,
      preStateLedger: consentsState?.consentsLedger,
      countryCode,
      option,
    });
    console.log('sortedConsentListData ', sortedConsentListData);
  }, [option, countryCode, consentsReponse]);

  const isValidationErrorFound = consentsState.error.type === ConsentErrorType.INTERNAL_VALIDATION_ERROR;

  return (
    <StyledLegalConsents data-component-name="o-legal-LegalConsents">
      {loading && (customLoader || <div data-testid="skeleton-loader" className="skeleton-loader"></div>)}
      {isValidationErrorFound && (
        <Messages messageType="error-sev1" className="mb-4" messageText={consentsState.error.message!} />
      )}
      {!loading && (
        <ConsentsList
          consentState={consentsState}
          onConsentChange={onConsentChange}
          validateErrors={isValidateErrors}
        />
      )}
    </StyledLegalConsents>
  );
};
